import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetTeamMemberDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/TeamMember/GetDetail?` + params, null);

export const GetTeamMemberList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/TeamMember/GetList?` + params, null);

export const GetLocationtoTeamMemberList = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/TeamMember/GetLocationToTeamMemberList?` + params,
    null,
  );

export const GetMultipleTeamMemberList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/TeamMember/GetMultipleList?` + params, null);

export const CreateTeamMember = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/Create`, data, true);

export const UpdateTeamMember = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/Update`, data, true);

export const DeleteTeamMember = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/Delete`, data);

export const GetDepartmentList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Department/GetList?` + params, null);

export const CreateTeamMemberLocationMapping = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/CreateTeamMemberLocationMapping`, data);

export const UpdateTeamMemberLocationMapping = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/UpdateTeamMemberLocationMapping`, data);

export const DeleteOutReachLocation = (data: any) =>
  POST_ENC(`${BASE_URL}/api/TeamMember/DeleteOutReachLocation`, data);

export const GetTeamMemberLocationList = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/TeamMember/GetTeamMemberLocationList?` + params,
    null,
  );

export const GetMultipleTeamMemberLocationList = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/TeamMember/GetMultipleTeamMemberLocationList?` + params,
    null,
  );
